
























































import {Component, Prop, Watch} from "vue-property-decorator"
import BaseVue from "@/utils/BaseVue"
import logger from "@/utils/logging"
import {Product, ProductsUpdateBody, ProductCategories} from "@/services/models.types"
import apiService from "@/services/api.service"

@Component
export default class ProductListEditor extends BaseVue {
    @Prop() private productListId!: string
    @Prop() private storeId!: number

    private created() {
        this.onProductListIdChanged()
    }

    @Watch("productListId")
    private onProductListIdChanged() {
        logger.debug(`Product List Id changed to #${this.productListId}. Loading data...`)
        this.$typedStore.actions.products.loadList(this.productListId)
        this.$typedStore.actions.stores.syncStoreEnabledProducts(this.storeId)
    }

    private get isDataLoading() {
        return (this.$typedStore.state.products[this.productListId].data === undefined
            && this.$typedStore.getters.products.isListLoading(this.productListId))
    }

    private get loadingError(): { header: string, message: string } | null {
        const error = this.$typedStore.state.products[this.productListId].error
        return error !== null ? {
            header: error.code === "not_found"
                ? "Vi kunne desvære ikke finde varelisten"
                : "Hov, vi oplever et problem lige nu",
            message: error.code === "not_found"
                ? "Vær sikker på, du har valgt en vareliste, du har adgang til i venstre menu."
                : `Prøv venligst igen. En ukendt fejl er opstået: '${error.message}'`,
        } : null
    }

    private get productListName(): string {
        return !this.isDataLoading
            ? this.$typedStore.state.products[this.productListId].data!.name
            : "\u00A0"
    }

    private get items(): Array<(Product & { isEnabled: boolean })> {
        return this.$typedStore.getters.products.getProductsInList(this.productListId)
            .map((item) => ({...item, isEnabled: this.isItemEnabled(item)}))
    }

    private get isBreadCategory(): boolean {
        return !this.isDataLoading
            ? this.$typedStore.state.products[this.productListId].data!.category === ProductCategories.BREAD
            : false
    }

    private isItemEnabled(item: Product) {
        return this.$typedStore.state.stores[this.storeId].data!.enabledProducts
            .some((enabledProduct) => enabledProduct.id === item.id && enabledProduct.listId === this.productListId)
    }

    private async onEnableAll() {
        logger.debug(`Selecting all items in product list #${this.productListId}...`)
        try {
            await this.$typedStore.actions.stores.updateProductsStatus(
                this.storeId,
                this.createProductsUpdateBody(true, this.items),
            )
        } catch (e) {
            this.$toasted.error(`Der opstod en fejl da du aktiverede alle varerne. Prøv venligst igen.`, {
                icon: "exclamation triangle icon",
            })
        }
    }

    private async onDisableAll() {
        logger.debug(`Disabling all items in product list #${this.productListId}...`)
        try {
            await this.$typedStore.actions.stores.updateProductsStatus(
                this.storeId,
                this.createProductsUpdateBody(false, this.items))
        } catch (e) {
            this.$toasted.error(`Der opstod en fejl da du deaktiverede alle varerne. Prøv venligst igen.`, {
                icon: "exclamation triangle icon",
            })
        }
    }

    private async onItemToggled(item: Product & { isEnabled: boolean }) {
        logger.debug(`Changing item #${item.id} enabled status to: ${!item.isEnabled}`)
        try {
            await this.$typedStore.actions.stores.updateProductsStatus(
                this.storeId,
                this.createProductsUpdateBody(!item.isEnabled, [item]))
        } catch (e) {
            this.$toasted.error(`Der opstod en fejl da du ændrede på '${item.displayName}'. Prøv venligst igen.`, {
                icon: "exclamation triangle icon",
            })
        }
    }

    private createProductsUpdateBody(
        enabled: boolean,
        items: Array<(Product & { isEnabled: boolean })> ): ProductsUpdateBody {

        return {
            listId: this.productListId,
            productUpdates: items.map((item) => ({
                id: item.id,
                isEnabled: enabled,
            })),
    }
  }
    }
